import {
  CampaignNoiseProcessingRequestDto,
  CampaignNoiseProcessingResponseDto,
} from '@shared/services/apiService/apiService';

import {
  NoiseCancellationDraft,
  NoiseCancellationValidation,
  cloneNoiseCancellationDraft,
  mapNoiseCancellationToDraft,
  mapNoiseCancellationDraftToRequest,
  validateNoiseCancellationDraft,
} from './noiseProcessing.utils';

export type CampaignNoiseCancellationDraft = NoiseCancellationDraft & {
  enabled: boolean;
};

export const mapCampaignNoiseCancellationToDraft = (
  value?: CampaignNoiseProcessingResponseDto | null,
): CampaignNoiseCancellationDraft => ({
  ...mapNoiseCancellationToDraft(value?.noiseCancellationSettings),
  configured: Boolean(value?.noiseCancellationSettings),
  enabled: Boolean(value?.noiseCancellationSettings?.enabled),
});

export const cloneCampaignNoiseCancellationDraft = (
  draft: CampaignNoiseCancellationDraft,
): CampaignNoiseCancellationDraft => ({
  ...cloneNoiseCancellationDraft(draft),
  enabled: draft.enabled,
});

export const validateCampaignNoiseCancellationDraft = (
  draft: CampaignNoiseCancellationDraft,
): NoiseCancellationValidation => {
  if (!draft.configured) {
    return draft.enabled ? { enabled: 'noiseProcessing.validation.enabledSettingsRequired' } : {};
  }

  return validateNoiseCancellationDraft(draft);
};

export const mapCampaignNoiseCancellationDraftToRequest = (
  draft: CampaignNoiseCancellationDraft,
): CampaignNoiseProcessingRequestDto => {
  const request: CampaignNoiseProcessingRequestDto = {
    noiseCancellationSettings: draft.configured
      ? {
          ...mapNoiseCancellationDraftToRequest(draft),
          enabled: draft.enabled,
        }
      : null,
  };

  return request;
};
